// FlixPlayer.js
'use strict';
import { connect } from 'react-redux';
import withRouter from '../component/WithRouter.jsx';

import { PREVIEW_PRESET } from '../RemoteConfigKeys.js';

import FlixPlayer from '../component/FlixPlayer.jsx';

import setPlayerData from '../action/setPlayerData.js';
import fetchDrmLicenseAvailability from '../action/fetchDrmLicenseAvailability.js';
import toggleDisturbing from '../action/toggleDisturbing.js';
import checkUserFlixHelpId from '../action/checkUserFlixHelpId.js';

import getMessageData from '../selector/getMessageData.js';
import getMessageDuration from '../selector/getMessageDuration.js';
import getOperationData from '../selector/getOperationData.js';
import getMeData from '../selector/getMeData.js';
import getUserData from '../selector/getUserData.js';
import getUrlTimecode from '../selector/getUrlTimecode.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';
import getListData from '../selector/getListData.js';

import { getKeySystem } from '../resource/getDrmInfo.js';
import getIsMatchedPathname from '../resource/getIsMatchedPathname.js';

import { breakpoint } from '../style/variables.js';

const mapStateToProps = (state, { messageId, location }) => {
  const [notificationId] =
    getListData(state, ['popupNotification', 'topVideo'], 'itemIds') || [];
  const senderId = getMessageData(state, messageId, 'senderId');
  const deviceWidth = getOperationData(state, ['device'], 'width');
  const canViewMedia = getMessageData(state, messageId, 'canViewMedia');
  const viewScope = getMessageData(state, messageId, 'viewScope');
  const isPreview = viewScope === 'preview';
  const isUnlocked = viewScope === 'sd' || viewScope === 'hd';
  const shouldDisturb =
    isUnlocked && getOperationData(state, ['disturbing'], 'shouldDisturb');
  return {
    notificationId,
    meId: getMeData(state, 'id'),
    senderId,
    username: getMeData(state, 'username'),
    badges: getMessageData(state, messageId, 'badges'),
    // flixDetail will fetchUser, so FlixPlayer don't need to do that.
    senderName: getUserData(state, senderId, 'username'),
    duration: getMessageDuration(state, messageId, location?.pathname),
    isFullscreen: getOperationData(state, ['player'], 'isFullscreen'),
    isMuted: getOperationData(state, ['player'], 'isMuted'),
    isVideoControlDisplayed: getOperationData(
      state,
      ['player'],
      'isVideoControlDisplayed'
    ),
    controlDisplayedMessageId: getOperationData(
      state,
      ['player'],
      'controlDisplayedMessageId'
    ),
    isPreview,
    isUnlocked,
    canViewMedia,
    shouldDisturb,
    isOnPostDetail: getIsMatchedPathname({
      pathname: location?.pathname,
      dataKey: 'isOnPostDetail',
    }),
    isOnMobile: deviceWidth <= breakpoint.tablet,
    isAgeVerified: getRemoteConfigData(state, PREVIEW_PRESET) === 'clear',
    timecode: getUrlTimecode(state),
    splashVideo: getRemoteConfigData(state, 'splashVideo'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setPlayerData: data => dispatch(setPlayerData(data)),
    fetchViewScope: ({ id }) =>
      dispatch(
        fetchDrmLicenseAvailability({
          messageId: id,
          keySystem: getKeySystem(),
        })
      ),
    toggleDisturbing: data => dispatch(toggleDisturbing(data)),
    checkUserFlixHelpId: () => dispatch(checkUserFlixHelpId()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FlixPlayer)
);
